






























































import 'vue-material-design-icons/styles.css'
import Ribbon from 'vue-ribbon'
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle'
import RightIcon from 'vue-material-design-icons/ChevronRightCircle'
import PlusIcon from 'vue-material-design-icons/PlusCircle'
import MinusIcon from 'vue-material-design-icons/MinusCircle'
import Flipbook from './Flipbook'

export default
  name: 'app'
  components: { Flipbook, LeftIcon, RightIcon, PlusIcon, MinusIcon, Ribbon }
  data: ->
    pages: [],
    pagesHiRes: [],
    hasMouse: true
    pageNum: null
  methods:
    onFlipLeftStart: (page) -> console.log 'flip-left-start', page
    onFlipLeftEnd: (page) ->
      console.log 'flip-left-end', page
      window.location.hash = '#' + page
    onFlipRightStart: (page) -> console.log 'flip-right-start', page
    onFlipRightEnd: (page) ->
      console.log 'flip-right-end', page
      window.location.hash = '#' + page
    onZoomStart: (zoom) -> console.log 'zoom-start', zoom
    onZoomEnd: (zoom) -> console.log 'zoom-end', zoom
    setPageFromHash: ->
      n = parseInt window.location.hash.slice(1), 10
      @pageNum = n if isFinite n
  mounted: ->
    window.addEventListener 'keydown', (ev) =>
      flipbook = @$refs.flipbook
      return unless flipbook
      flipbook.flipLeft() if ev.keyCode == 37 and flipbook.canFlipLeft
      flipbook.flipRight() if ev.keyCode == 39 and flipbook.canFlipRight

    # Simulate asynchronous pages initialization
    setTimeout (=>
      @pages = [
        null
        'images/1.jpg'
        'images/2.jpg'
        'images/3.jpg'
        'images/4.jpg'
        'images/5.jpg'
        'images/6.jpg'
        'images/7.jpg'
        'images/8.jpg'
        'images/9.jpg'
        'images/10.jpg'
        'images/11.jpg'
        'images/12.jpg'
        'images/13.jpg'
        'images/14.jpg'
        'images/15.jpg'
        'images/16.jpg'
        'images/17.jpg'
        'images/18.jpg'
        'images/19.jpg'
        'images/20.jpg'
        'images/21.jpg'
        'images/22.jpg'
        'images/23.jpg'
        'images/24.jpg'
        'images/25.jpg'
        'images/26.jpg'
        'images/27.jpg'
        'images/28.jpg'
        'images/29.jpg'
        'images/30.jpg'
        'images/31.jpg'
        'images/32.jpg'
        'images/33.jpg'
        'images/34.jpg'
        'images/35.jpg'
        'images/36.jpg'
        'images/37.jpg'
        'images/38.jpg'
        'images/39.jpg'
        'images/40.jpg'
        'images/41.jpg'
        'images/42.jpg'
        'images/43.jpg'
        'images/44.jpg'
        'images/45.jpg'
        'images/46.jpg'
        'images/47.jpg'
        'images/48.jpg'
        'images/49.jpg'
        'images/50.jpg'
        'images/51.jpg'
        'images/52.jpg'
        'images/53.jpg'
        'images/54.jpg'
        'images/55.jpg'
        'images/56.jpg'
        'images/57.jpg'
        'images/58.jpg'
        'images/59.jpg'
        'images/60.jpg'
        'images/61.jpg'
        'images/62.jpg'
        'images/63.jpg'
        'images/64.jpg'
        'images/65.jpg'
        'images/66.jpg'
        'images/67.jpg'
        'images/68.jpg'
        'images/69.jpg'
        'images/70.jpg'
        'images/71.jpg'
        'images/72.jpg'
        'images/73.jpg'
        'images/74.jpg'
        'images/75.jpg'
        'images/76.jpg'
        'images/77.jpg'
        'images/78.jpg'
        'images/79.jpg'
        'images/80.jpg'
        'images/81.jpg'
        'images/82.jpg'
        'images/83.jpg'
        'images/84.jpg'
        'images/85.jpg'
        'images/86.jpg'
        'images/87.jpg'
        'images/88.jpg'
        'images/89.jpg'
        'images/90.jpg'
        'images/91.jpg'
        'images/92.jpg'
        'images/93.jpg'
        'images/94.jpg'
        'images/95.jpg'
        'images/96.jpg'
        'images/97.jpg'
        'images/98.jpg'
        'images/99.jpg'
        'images/100.jpg'
        'images/101.jpg'
        'images/102.jpg'
        'images/103.jpg'
        'images/104.jpg'
        'images/105.jpg'
        'images/106.jpg'
        'images/107.jpg'
        'images/108.jpg'
        'images/109.jpg'
        'images/110.jpg'
        'images/111.jpg'
        'images/112.jpg'
        'images/113.jpg'
        'images/114.jpg'
        'images/115.jpg'
        'images/116.jpg'
        'images/117.jpg'
        'images/118.jpg'
        'images/119.jpg'
        'images/120.jpg'
        'images/121.jpg'
        'images/122.jpg'
        'images/123.jpg'
        'images/124.jpg'
        'images/125.jpg'
        'images/126.jpg'
        'images/127.jpg'
        'images/128.jpg'
        'images/129.jpg'
        'images/130.jpg'
        'images/131.jpg'
        'images/132.jpg'
        'images/133.jpg'
        'images/134.jpg'
        'images/135.jpg'
        'images/136.jpg'
        'images/137.jpg'
        'images/138.jpg'
        'images/139.jpg'
        'images/140.jpg'
        'images/141.jpg'
        'images/142.jpg'
        'images/143.jpg'
        'images/144.jpg'
        'images/145.jpg'
        'images/146.jpg'
        'images/147.jpg'
        'images/148.jpg'
        'images/149.jpg'
        'images/150.jpg'
        'images/151.jpg'
        'images/152.jpg'
        'images/153.jpg'
        'images/154.jpg'
        'images/155.jpg'
        'images/156.jpg'
        'images/157.jpg'
        'images/158.jpg'
        'images/159.jpg'
        'images/160.jpg'
        'images/161.jpg'
        'images/162.jpg'
        'images/163.jpg'
        'images/164.jpg'
        'images/165.jpg'
        'images/166.jpg'
        'images/167.jpg'
        'images/168.jpg'
        'images/169.jpg'
        'images/170.jpg'
        'images/171.jpg'
        'images/172.jpg'
        'images/173.jpg'
        'images/174.jpg'
        'images/175.jpg'
        'images/176.jpg'
        'images/177.jpg'
        'images/178.jpg'
        'images/179.jpg'
        'images/180.jpg'
        'images/181.jpg'
        'images/182.jpg'
        'images/183.jpg'
        'images/184.jpg'
        'images/185.jpg'
        'images/186.jpg'
        'images/187.jpg'
        'images/188.jpg'
        'images/189.jpg'
        'images/190.jpg'
        'images/191.jpg'
        'images/192.jpg'
        'images/193.jpg'
        'images/194.jpg'
        'images/195.jpg'
        'images/196.jpg'
        'images/197.jpg'
        'images/198.jpg'
        'images/199.jpg'
        'images/200.jpg'
        'images/201.jpg'
        'images/202.jpg'
        'images/203.jpg'
        'images/204.jpg'
        'images/205.jpg'
        'images/206.jpg'
        'images/207.jpg'
        'images/208.jpg'
        'images/209.jpg'
        'images/210.jpg'
        'images/211.jpg'
        'images/212.jpg'
        'images/213.jpg'
        'images/214.jpg'
        'images/215.jpg'
        'images/216.jpg'
        'images/217.jpg'
        'images/218.jpg'
        'images/219.jpg'
        'images/220.jpg'
        'images/221.jpg'
        'images/222.jpg'
        'images/223.jpg'
        'images/224.jpg'
        'images/225.jpg'
        'images/226.jpg'
        'images/227.jpg'
        'images/228.jpg'
        'images/229.jpg'
        'images/230.jpg'
        'images/231.jpg'
        'images/232.jpg'
        'images/233.jpg'
        'images/234.jpg'
        'images/235.jpg'
        'images/236.jpg'
        'images/237.jpg'
        'images/238.jpg'
        'images/239.jpg'
        'images/240.jpg'
        'images/241.jpg'
        'images/242.jpg'
        'images/243.jpg'
        'images/244.jpg'
        'images/245.jpg'
        'images/246.jpg'
        'images/247.jpg'
        'images/248.jpg'
        'images/249.jpg'
        'images/250.jpg'
        'images/251.jpg'
        'images/252.jpg'
        'images/253.jpg'
        'images/254.jpg'
        'images/255.jpg'
        'images/256.jpg'
        'images/257.jpg'
        'images/258.jpg'
        'images/259.jpg'
        'images/260.jpg'
        'images/261.jpg'
        'images/262.jpg'
        'images/263.jpg'
        'images/264.jpg'
        'images/265.jpg'
        'images/266.jpg'
        'images/267.jpg'
        'images/268.jpg'
        'images/269.jpg'
        'images/270.jpg'
        'images/271.jpg'
        'images/272.jpg'
        'images/273.jpg'
        'images/274.jpg'
        'images/275.jpg'
        'images/276.jpg'
        'images/277.jpg'
        'images/278.jpg'
        'images/279.jpg'
        'images/280.jpg'
        'images/281.jpg'
        'images/282.jpg'
        'images/283.jpg'
        'images/284.jpg'
        'images/285.jpg'
        'images/286.jpg'
        'images/287.jpg'
        'images/288.jpg'
        'images/289.jpg'
        'images/290.jpg'
        'images/291.jpg'
        'images/292.jpg'
        'images/293.jpg'
        'images/294.jpg'
        'images/295.jpg'
        'images/296.jpg'
        'images/297.jpg'
        'images/298.jpg'
        'images/299.jpg'
        'images/300.jpg'
        'images/301.jpg'
        'images/302.jpg'
        'images/303.jpg'
        'images/304.jpg'
        'images/305.jpg'
        'images/306.jpg'
        'images/307.jpg'
        'images/308.jpg'
        'images/309.jpg'
        'images/310.jpg'
        'images/311.jpg'
        'images/312.jpg'
        'images/313.jpg'
        'images/314.jpg'
        'images/315.jpg'
        'images/316.jpg'
        'images/317.jpg'
        'images/318.jpg'
        'images/319.jpg'
        'images/320.jpg'
        'images/321.jpg'
        'images/322.jpg'
        'images/323.jpg'
        'images/324.jpg'
        'images/325.jpg'
        'images/326.jpg'
        'images/327.jpg'
        'images/328.jpg'
        'images/329.jpg'
        'images/330.jpg'
        'images/331.jpg'
        'images/332.jpg'
        'images/333.jpg'
        'images/334.jpg'
        'images/335.jpg'
        'images/336.jpg'
        'images/337.jpg'
        'images/338.jpg'
        'images/339.jpg'
        'images/340.jpg'
        'images/341.jpg'
        'images/342.jpg'
        'images/343.jpg'
        'images/344.jpg'
        
      ]
      @pagesHiRes = [
        null
        'images-large/1.jpg'
        'images-large/2.jpg'
        'images-large/3.jpg'
        'images-large/4.jpg'
        'images-large/5.jpg'
        'images-large/6.jpg'
        'images-large/7.jpg'
        'images-large/8.jpg'
        'images-large/9.jpg'
        'images-large/10.jpg'
        'images-large/11.jpg'
        'images-large/12.jpg'
        'images-large/13.jpg'
        'images-large/14.jpg'
        'images-large/15.jpg'
        'images-large/16.jpg'
        'images-large/17.jpg'
        'images-large/18.jpg'
        'images-large/19.jpg'
        'images-large/20.jpg'
        'images-large/21.jpg'
        'images-large/22.jpg'
        'images-large/23.jpg'
        'images-large/24.jpg'
        'images-large/25.jpg'
        'images-large/26.jpg'
        'images-large/27.jpg'
        'images-large/28.jpg'
        'images-large/29.jpg'
        'images-large/30.jpg'
        'images-large/31.jpg'
        'images-large/32.jpg'
        'images-large/33.jpg'
        'images-large/34.jpg'
        'images-large/35.jpg'
        'images-large/36.jpg'
        'images-large/37.jpg'
        'images-large/38.jpg'
        'images-large/39.jpg'
        'images-large/40.jpg'
        'images-large/41.jpg'
        'images-large/42.jpg'
        'images-large/43.jpg'
        'images-large/44.jpg'
        'images-large/45.jpg'
        'images-large/46.jpg'
        'images-large/47.jpg'
        'images-large/48.jpg'
        'images-large/49.jpg'
        'images-large/50.jpg'
        'images-large/51.jpg'
        'images-large/52.jpg'
        'images-large/53.jpg'
        'images-large/54.jpg'
        'images-large/55.jpg'
        'images-large/56.jpg'
        'images-large/57.jpg'
        'images-large/58.jpg'
        'images-large/59.jpg'
        'images-large/60.jpg'
        'images-large/61.jpg'
        'images-large/62.jpg'
        'images-large/63.jpg'
        'images-large/64.jpg'
        'images-large/65.jpg'
        'images-large/66.jpg'
        'images-large/67.jpg'
        'images-large/68.jpg'
        'images-large/69.jpg'
        'images-large/70.jpg'
        'images-large/71.jpg'
        'images-large/72.jpg'
        'images-large/73.jpg'
        'images-large/74.jpg'
        'images-large/75.jpg'
        'images-large/76.jpg'
        'images-large/77.jpg'
        'images-large/78.jpg'
        'images-large/79.jpg'
        'images-large/80.jpg'
        'images-large/81.jpg'
        'images-large/82.jpg'
        'images-large/83.jpg'
        'images-large/84.jpg'
        'images-large/85.jpg'
        'images-large/86.jpg'
        'images-large/87.jpg'
        'images-large/88.jpg'
        'images-large/89.jpg'
        'images-large/90.jpg'
        'images-large/91.jpg'
        'images-large/92.jpg'
        'images-large/93.jpg'
        'images-large/94.jpg'
        'images-large/95.jpg'
        'images-large/96.jpg'
        'images-large/97.jpg'
        'images-large/98.jpg'
        'images-large/99.jpg'
        'images-large/100.jpg'
        'images-large/101.jpg'
        'images-large/102.jpg'
        'images-large/103.jpg'
        'images-large/104.jpg'
        'images-large/105.jpg'
        'images-large/106.jpg'
        'images-large/107.jpg'
        'images-large/108.jpg'
        'images-large/109.jpg'
        'images-large/110.jpg'
        'images-large/111.jpg'
        'images-large/112.jpg'
        'images-large/113.jpg'
        'images-large/114.jpg'
        'images-large/115.jpg'
        'images-large/116.jpg'
        'images-large/117.jpg'
        'images-large/118.jpg'
        'images-large/119.jpg'
        'images-large/120.jpg'
        'images-large/121.jpg'
        'images-large/122.jpg'
        'images-large/123.jpg'
        'images-large/124.jpg'
        'images-large/125.jpg'
        'images-large/126.jpg'
        'images-large/127.jpg'
        'images-large/128.jpg'
        'images-large/129.jpg'
        'images-large/130.jpg'
        'images-large/131.jpg'
        'images-large/132.jpg'
        'images-large/133.jpg'
        'images-large/134.jpg'
        'images-large/135.jpg'
        'images-large/136.jpg'
        'images-large/137.jpg'
        'images-large/138.jpg'
        'images-large/139.jpg'
        'images-large/140.jpg'
        'images-large/141.jpg'
        'images-large/142.jpg'
        'images-large/143.jpg'
        'images-large/144.jpg'
        'images-large/145.jpg'
        'images-large/146.jpg'
        'images-large/147.jpg'
        'images-large/148.jpg'
        'images-large/149.jpg'
        'images-large/150.jpg'
        'images-large/151.jpg'
        'images-large/152.jpg'
        'images-large/153.jpg'
        'images-large/154.jpg'
        'images-large/155.jpg'
        'images-large/156.jpg'
        'images-large/157.jpg'
        'images-large/158.jpg'
        'images-large/159.jpg'
        'images-large/160.jpg'
        'images-large/161.jpg'
        'images-large/162.jpg'
        'images-large/163.jpg'
        'images-large/164.jpg'
        'images-large/165.jpg'
        'images-large/166.jpg'
        'images-large/167.jpg'
        'images-large/168.jpg'
        'images-large/169.jpg'
        'images-large/170.jpg'
        'images-large/171.jpg'
        'images-large/172.jpg'
        'images-large/173.jpg'
        'images-large/174.jpg'
        'images-large/175.jpg'
        'images-large/176.jpg'
        'images-large/177.jpg'
        'images-large/178.jpg'
        'images-large/179.jpg'
        'images-large/180.jpg'
        'images-large/181.jpg'
        'images-large/182.jpg'
        'images-large/183.jpg'
        'images-large/184.jpg'
        'images-large/185.jpg'
        'images-large/186.jpg'
        'images-large/187.jpg'
        'images-large/188.jpg'
        'images-large/189.jpg'
        'images-large/190.jpg'
        'images-large/191.jpg'
        'images-large/192.jpg'
        'images-large/193.jpg'
        'images-large/194.jpg'
        'images-large/195.jpg'
        'images-large/196.jpg'
        'images-large/197.jpg'
        'images-large/198.jpg'
        'images-large/199.jpg'
        'images-large/200.jpg'
        'images-large/201.jpg'
        'images-large/202.jpg'
        'images-large/203.jpg'
        'images-large/204.jpg'
        'images-large/205.jpg'
        'images-large/206.jpg'
        'images-large/207.jpg'
        'images-large/208.jpg'
        'images-large/209.jpg'
        'images-large/210.jpg'
        'images-large/211.jpg'
        'images-large/212.jpg'
        'images-large/213.jpg'
        'images-large/214.jpg'
        'images-large/215.jpg'
        'images-large/216.jpg'
        'images-large/217.jpg'
        'images-large/218.jpg'
        'images-large/219.jpg'
        'images-large/220.jpg'
        'images-large/221.jpg'
        'images-large/222.jpg'
        'images-large/223.jpg'
        'images-large/224.jpg'
        'images-large/225.jpg'
        'images-large/226.jpg'
        'images-large/227.jpg'
        'images-large/228.jpg'
        'images-large/229.jpg'
        'images-large/230.jpg'
        'images-large/231.jpg'
        'images-large/232.jpg'
        'images-large/233.jpg'
        'images-large/234.jpg'
        'images-large/235.jpg'
        'images-large/236.jpg'
        'images-large/237.jpg'
        'images-large/238.jpg'
        'images-large/239.jpg'
        'images-large/240.jpg'
        'images-large/241.jpg'
        'images-large/242.jpg'
        'images-large/243.jpg'
        'images-large/244.jpg'
        'images-large/245.jpg'
        'images-large/246.jpg'
        'images-large/247.jpg'
        'images-large/248.jpg'
        'images-large/249.jpg'
        'images-large/250.jpg'
        'images-large/251.jpg'
        'images-large/252.jpg'
        'images-large/253.jpg'
        'images-large/254.jpg'
        'images-large/255.jpg'
        'images-large/256.jpg'
        'images-large/257.jpg'
        'images-large/258.jpg'
        'images-large/259.jpg'
        'images-large/260.jpg'
        'images-large/261.jpg'
        'images-large/262.jpg'
        'images-large/263.jpg'
        'images-large/264.jpg'
        'images-large/265.jpg'
        'images-large/266.jpg'
        'images-large/267.jpg'
        'images-large/268.jpg'
        'images-large/269.jpg'
        'images-large/270.jpg'
        'images-large/271.jpg'
        'images-large/272.jpg'
        'images-large/273.jpg'
        'images-large/274.jpg'
        'images-large/275.jpg'
        'images-large/276.jpg'
        'images-large/277.jpg'
        'images-large/278.jpg'
        'images-large/279.jpg'
        'images-large/280.jpg'
        'images-large/281.jpg'
        'images-large/282.jpg'
        'images-large/283.jpg'
        'images-large/284.jpg'
        'images-large/285.jpg'
        'images-large/286.jpg'
        'images-large/287.jpg'
        'images-large/288.jpg'
        'images-large/289.jpg'
        'images-large/290.jpg'
        'images-large/291.jpg'
        'images-large/292.jpg'
        'images-large/293.jpg'
        'images-large/294.jpg'
        'images-large/295.jpg'
        'images-large/296.jpg'
        'images-large/297.jpg'
        'images-large/298.jpg'
        'images-large/299.jpg'
        'images-large/300.jpg'
        'images-large/301.jpg'
        'images-large/302.jpg'
        'images-large/303.jpg'
        'images-large/304.jpg'
        'images-large/305.jpg'
        'images-large/306.jpg'
        'images-large/307.jpg'
        'images-large/308.jpg'
        'images-large/309.jpg'
        'images-large/310.jpg'
        'images-large/311.jpg'
        'images-large/312.jpg'
        'images-large/313.jpg'
        'images-large/314.jpg'
        'images-large/315.jpg'
        'images-large/316.jpg'
        'images-large/317.jpg'
        'images-large/318.jpg'
        'images-large/319.jpg'
        'images-large/320.jpg'
        'images-large/321.jpg'
        'images-large/322.jpg'
        'images-large/323.jpg'
        'images-large/324.jpg'
        'images-large/325.jpg'
        'images-large/326.jpg'
        'images-large/327.jpg'
        'images-large/328.jpg'
        'images-large/329.jpg'
        'images-large/330.jpg'
        'images-large/331.jpg'
        'images-large/332.jpg'
        'images-large/333.jpg'
        'images-large/334.jpg'
        'images-large/335.jpg'
        'images-large/336.jpg'
        'images-large/337.jpg'
        'images-large/338.jpg'
        'images-large/339.jpg'
        'images-large/340.jpg'
        'images-large/341.jpg'
        'images-large/342.jpg'
        'images-large/343.jpg'
        'images-large/344.jpg'
      ]
    ), 1

    window.addEventListener 'hashchange', @setPageFromHash
    @setPageFromHash()
